import { makeStyles } from '@material-ui/core/styles'
import { Theme, MenuItem, Grid } from '@material-ui/core'
import { useIntl } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  specificationItem,
  SemiConfigFormValues,
} from '../ProductsConfiguration'
import LiquidSelect from '@src/components/LiquidSelect'
import LiquidFormLabel from '@src/components/LiquidFormLabel'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'

const useStyles = makeStyles((theme: Theme) => ({
  dropDown: {
    paddingTop: theme.spacing(2),
  },
  fitContent: {
    width: 'fit-content',
    minWidth: '200px', // Ensure minimum readable width
  },
}))

interface SpecificationSelectProps {
  list: specificationItem[]
  fieldName: string
  specificationLabel: React.ReactNode
  specificationValue: string | undefined
  handleChange: (f: string, v: string) => void
  showRequiredError?: boolean
  fitContent?: boolean
  defaultValue?: {
    key: string
    value: string
  }
}

const SpecificationSelect = ({
  list,
  fieldName,
  specificationLabel,
  specificationValue,
  handleChange,
  showRequiredError = false,
  fitContent = false,
  defaultValue,
}: SpecificationSelectProps) => {
  const classes = useStyles()
  const intl = useIntl()
  const formik = useFormikContext<SemiConfigFormValues>()

  const onChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    handleChange(fieldName, e.target.value as string)
  }

  // Determine if should use fit-content styling
  const shouldFitContent =
    fitContent && specificationValue && specificationValue !== ''

  const selectOption = {
    key: '',
    value: intl.formatMessage({
      id: 'PC_SPEC_SELECT_antisera',
      defaultMessage: 'Select',
    }),
  }
  const defaultOption = defaultValue ? defaultValue : selectOption
  return (
    <Grid xs={12}>
      <Grid
        item
        xs={12}
        sm={shouldFitContent ? undefined : 4}
        md={shouldFitContent ? undefined : 3}
        className={`${classes.dropDown} ${shouldFitContent ? classes.fitContent : ''}`}
      >
        <LiquidFormLabel>{specificationLabel}</LiquidFormLabel>
        <LiquidSelect
          value={specificationValue}
          onChange={onChange}
          displayEmpty
          fullWidth={!shouldFitContent}
        >
          {[defaultOption].concat(list).map((item) => (
            <MenuItem key={item.key} value={item.key}>
              {item.value}
            </MenuItem>
          ))}
        </LiquidSelect>
      </Grid>
      {showRequiredError &&
        specificationValue === '' &&
        formik.values.displayPageError &&
        formik.values.completedStep >= 2 && (
          <ValidationErrors
            errors={[
              intl.formatMessage({
                id: 'CONF_REQUIRED_FIELD',
                defaultMessage: 'Required Field',
              }),
            ]}
            configuratorsRedesign
          />
        )}
    </Grid>
  )
}

export default SpecificationSelect
